export default __webpack_public_path__ + "static/media/part_logo2.d3a05440.png";